import $ from 'jquery';
import Marionette from 'backbone.marionette';

var _reorderRemoveAndCloseFunctions;
var _createDialog;

export default {
    /** A reference to the jquery dialog instance */
    jqueryDialog: undefined,

    /** Closes the jquery dialog.  Must be called with the backbone view instance as the context. */
    closeJqueryDialog() {
        this.jqueryDialog && this.jqueryDialog.dialog('close');
    },

    /** Transforms the view into a jquery dialog */
    transformToJqueryDialog(options) {
        let thisView = this;
        let dialogOptions = $.extend({}, options);
        if (dialogOptions.show === true || typeof dialogOptions.show === 'undefined') {
            dialogOptions.show = 100; // jquery will do `options.complete = callback` which fails in strict mode when options is `true`
        }
        _reorderRemoveAndCloseFunctions(thisView, dialogOptions);
        _createDialog(thisView, dialogOptions);
        return this.jqueryDialog;
    },

    /** Centers the dialog in the window. Useful in situations where the dialog's content changed and we want to re-center it */
    centerDialog() {
        if (this.doesDialogExist()) {
            this.jqueryDialog.dialog('option', 'position', { my: 'center', at: 'center', of: window });
        }
    },

    /** Returns whether or not the dialog currently exists (not necessarily whether it's visible), i.e. it's been created and hasn't been
     *  destroyed/removed since */
    doesDialogExist() {
        // we only want to operate on the dialog if it currently exists or jquery will throw a fit
        return Boolean(this.jqueryDialog.dialog('instance'));
    }
};

/**
 * Replaces the view's remove() function with a call to the dialog's close function, and updates the provided close
 * callback to call the view's original remove() function afterward.  The former ensures that programmatically
 * calling remove() closes the dialog via the dialog's normal means so 'close' event handlers are fired and any
 * configured dialog close animations are run (as opposed to immediately destroying the dom element as Backbone's
 * remove() does).  The latter ensures that when the dialog is closed in any way (e.g. calling remove(), clicking
 * the X, calling dialog('close'), etc.) the view's remove() function is called last to ensure all view cleanup
 * gets run properly and only after all close handlers and callbacks have had the chance to run.
 * @param thisView the view instance we're transforming
 * @param dialogOptions the jquery-ui dialog options
 */
_reorderRemoveAndCloseFunctions = function (thisView, dialogOptions) {
    let originalDialogCloseCallback = dialogOptions.close;
    let originalViewRemoveFunction = thisView instanceof Marionette.View ? thisView.destroy : thisView.remove;

    const newViewRemoveFunction = function () {
        if (thisView.doesDialogExist()) {
            thisView.jqueryDialog.dialog('close');
        }
    };
    thisView.remove = newViewRemoveFunction;
    thisView.destroy = newViewRemoveFunction;

    // We augment the callback instead of adding a "close" handler because the handlers run before the callback
    dialogOptions.close = function () {
        if (typeof originalDialogCloseCallback === 'function') {
            originalDialogCloseCallback.call(this); // use same context jquery called this function with
        }
        if (typeof originalViewRemoveFunction === 'function') {
            originalViewRemoveFunction.call(thisView); // use view as context since backbone views expect this
        }
    };
};

/**
 * Transform the view's $el into a jquery dialog, which will create a jquery dialog with $el as the content of the
 * dialog.  Then update the view's el/$el to be the top-most element of the dialog rather than just the inner
 * content so that the title bar and button bar is included in the view's $el.
 * @param thisView the view instance we're transforming
 * @param dialogOptions the jquery dialog options which will be passed to jquery's dialog() call
 */
_createDialog = function (thisView, dialogOptions) {
    thisView.jqueryDialog = thisView.$el.dialog(dialogOptions);
    thisView.setElement(thisView.jqueryDialog.dialog('widget'));
};
